import { render, staticRenderFns } from "./CardUser.vue?vue&type=template&id=2f042a10&scoped=true&"
import script from "./CardUser.vue?vue&type=script&lang=js&"
export * from "./CardUser.vue?vue&type=script&lang=js&"
import style0 from "./CardUser.vue?vue&type=style&index=0&id=2f042a10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f042a10",
  null
  
)

export default component.exports